<template>
  <router-link class="acceso-directo" :class="{simplificado: simplificado_activo}" 
    :to="to">
    <div class="imagen-acceso">
        <img class="imagen" :src="src" >
    </div>
    
    <div class="nombre-acceso">
        <p  >
            <span>{{titulo}}</span>
        </p>
    </div>
  </router-link>
</template>

<script>
export default {
  name: 'TarjetaAccesoDirecto',
  props: {
    titulo: {
      type: String,
      required: true,
    },
    to: {
        type: String
    },
    src: {
        type: String
    }
  },

  computed: {
    simplificado_activo(){
      return this.$store.getters.tieneVistaSimplificada
    }
  },
};
</script>

<style scoped lang="scss">
.acceso-directo{
    width: 25%;
    font-size: 16px;
    @media screen and (max-width: map-get($media-queries-limit, "mobile")) {
        width: 100%;
    }
    display: block;
    box-shadow: 3px 3px 4px #0000001F;
    border-radius: 10px;
    color: #141414;
    img.imagen{
        width: 100%;
        height: 178px;
        object-fit: cover;
        object-position: 50% 50%;
        opacity: 1;
        width: 100%;
        border-radius: 10px 10px 0 0;

    }
    .nombre-acceso{
        padding: 16px;
        
        font-weight: 500;
        p{
            margin: 0;
        }
    }
    &:hover{
        color: #141414;
        background: #fff;
        box-shadow: 6px 6px 8px #0000001F;

    }

    &.simplificado{
         box-shadow: none;
         text-decoration: underline;
        img.imagen{
            display: none;
        }
    }
}
</style>
